module.exports = __webpack_public_path__ + "img/how_to_play_bk_j.ee850df6.png";